import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { func } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'
import { BOTAO_FECHAR, TITULO_ERRO_COMPRA, TITULO_SUCESSO_COMPRA } from '../../constantsCardOpcionais'
import iconError from '../../../../assets/imagens/icon-error.svg'


const estiloErroTodosOpcionais = `
  h3 {
    color: ${StyleGuide.cores.vermelhoErro};
    &:before {
      background-image: url( ${iconError} );
      background-position: center;
      background-size: cover;
      content: '';
      display: block;
      margin: 0 auto;
      margin-bottom: 10px;
      height: 40px;
      width: 40px;
    }
  }
`

const estiloAlgumErroOpcionais = `
  .conclusao-modalidade-erro {
    color: ${StyleGuide.cores.vermelhoErro};
  }
`

const estiloAlgumSucessoOpcionais = `
  h3 {
    color: ${StyleGuide.cores.azul};

    &:before {
      display: none;
    }
  }
`

const WrapperConclusaoCartao = styled.div`
  text-align: center;

  & .conclusao-mensagem {
    font-size: 15px;
    line-height: 1.25;
    margin: 15px 0 40px;
  }


  ${( { comprasComErro, comprasComSucesso } ) => comprasComErro.length > 1 && !comprasComSucesso.length && estiloErroTodosOpcionais}
  ${( { comprasComSucesso } ) => comprasComSucesso.length >= 1 && estiloAlgumSucessoOpcionais}
  ${( { comprasComErro, comprasComSucesso } ) => comprasComErro.length && comprasComSucesso.length && estiloAlgumErroOpcionais}
`

const OpcionaisConclusaoCartao = ( { fecharModal } ) => {
  const { mesOpcional, respostaCompraOpcionais } = useOpcionais()
  const [ comprasComSucesso, setComprasComSucesso ] = useState( [] )
  const [ comprasComErro, setComprasComErro ] = useState( [] )

  useEffect( () => {
    if ( respostaCompraOpcionais.length ) {
      let respostaSucedida = []
      let respostaComErro = []
      // eslint-disable-next-line array-callback-return
      respostaCompraOpcionais.filter( resposta => {
        if ( resposta.erro ) {
          respostaComErro = [ ...respostaComErro, resposta.modalidade ]
        } else {
          respostaSucedida = [ ...respostaSucedida, resposta.modalidade ]
        }
      } )
      setComprasComSucesso( respostaSucedida )
      setComprasComErro( respostaComErro )
    }
  }, [ respostaCompraOpcionais ] )

  return (
    <WrapperConclusaoCartao
      comprasComErro={ comprasComErro }
      comprasComSucesso={ comprasComSucesso }
    >
      <h3
        className={ `${comprasComErro.length ? 'conclusao-titulo-erro' : ''}${comprasComSucesso.length ? 'conclusao-titulo-sucesso' : ''}` }
      >
        { comprasComSucesso.length ? TITULO_SUCESSO_COMPRA : TITULO_ERRO_COMPRA }
      </h3>

      { respostaCompraOpcionais.length && mesOpcional ? respostaCompraOpcionais.map( resposta => {
        return (
          <div
            key={ resposta.idAssinatura }
          >
            { respostaCompraOpcionais.length > 1 &&
            <p className={ `conclusao-modalidade${comprasComErro.includes( resposta.modalidade ) ? '-erro' : ''}` }>
              <strong>
                {resposta.modalidade}
              </strong>
            </p>}

            <p className="conclusao-mensagem">{ resposta.message }</p>
          </div>
        )
      } ) : null}

      <Button
        invertido
        onClick={ () => fecharModal() }
        tema={ comprasComSucesso.length ? Button.BOTAO_CURADORIA : Button.BOTAO_PRETO }
      >
        { BOTAO_FECHAR }
      </Button>
    </WrapperConclusaoCartao>
  )
}

OpcionaisConclusaoCartao.propTypes = {
  'fecharModal': func.isRequired
}

export default OpcionaisConclusaoCartao
